<template>
  <div class="view view--program-edit">
    <div class="has-margin-b30">
      <control
        name="nameControl"
        type="text"
        v-bind:label="__('Title')"
        v-model="organizer.title"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.title != null"
      >
        {{ errors.title[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <control
        name="addressControl"
        type="text"
        v-bind:label="__('Address')"
        v-model="organizer.address"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.address != null"
      >
        {{ errors.address[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <control
        name="emailControl"
        type="text"
        v-bind:label="__('Email')"
        v-model="organizer.email"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.email != null"
      >
        {{ errors.email[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <control
        name="registrationNumberControl"
        type="text"
        v-bind:label="__('Registration Number')"
        v-model="organizer.registrationNumber"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.registration_number != null"
      >
        {{ errors.registration_number[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <div class="control__group" v-if="!editMerchant">
        <label for="" class="control__label">{{ __('Simplepay Merchat') }}</label>
        <span v-on:click="isEditMerchant = true">
            <icon icon="edit" class="is-light-gray has-blue-hover has-margin-t10 cursor-pointer" />
        </span>
      </div>
      <control
        v-if="editMerchant"
        name="merchantControl"
        type="text"
        v-bind:label="__('Simplepay Merchant')"
        v-model="organizer.simplepayMerchant"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.simplepay_merchant != null"
      >
        {{ errors.simplepay_merchant[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <div class="control__group" v-if="!editSecret">
        <label for="" class="control__label">{{ __('Simplepay Secret') }}</label>
        <span v-on:click="isEditSecret = true">
            <icon icon="edit" class="is-light-gray has-blue-hover has-margin-t10 cursor-pointer" />
        </span>
      </div>
      <control
        name="secretControl"
        type="text"
        v-bind:label="__('Simplepay Secret')"
        v-model="organizer.simplepaySecret"
        v-if="editSecret"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.simplepay_secret != null"
      >
        {{ errors.simplepay_secret[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <control
        name="privacyPolicyControl"
        type="file"
        ref="privacyPolicyControl"
        v-bind:filename="organizer.privacyPolicyUrl"
        v-bind:label="__('Privacy Policy PDF')"
        v-model="organizer.privacyPolicyFile"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.privacy_policy != null"
      >
        {{ errors.privacy_policy[0] }}
      </div>
    </div>

    <div class="has-margin-b30">
      <control
        name="status"
        type="select"
        v-bind:label="__('Status')"
        v-model="organizer.status"
        v-bind:options="statuses"
        :is-disabled="!canEditStatus"
      />
      <div
        class="has-text-danger has-margin-b10"
        v-if="errors.status != null"
      >
        {{ errors.status[0] }}
      </div>
    </div>

    <btn
      class="is-success"
      type="default"
      v-html="__('Save')"
      v-on:click="updateOrganizer"
    ></btn>
  </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';
import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import router from '../../router';
import OrganizerRepository from '../../repositories/OrganizerRepository';
import { Icon } from "@teamfurther/cinderblock";

export default {
  components: {
    Btn,
    Control,
    Icon,
  },
  created: function() {
    this.organizerRepository = new OrganizerRepository();
  },
  computed: {
    editMerchant: function () {
      return !this.organizer.hasSimplepayMerchant || this.isEditMerchant;
    },
    editSecret: function () {
      return !this.organizer.hasSimplepaySecret || this.isEditSecret;
    },
    canEditStatus: function () {
      return (this.organizer.hasSimplepayMerchant && this.organizer.hasSimplepaySecret) ||
        (this.organizer.simplepayMerchant && this.organizer.simplepaySecret);
    },
  },
  data: function() {
    return {
      errors: {},
      organizerRepository: null,
      key: 0,
      statuses: [
        {
          label: 'Active',
          value: 'active',
        },
        {
          label: 'Inactive',
          value: 'inactive',
        }
      ],
      organizer: {
        id: null,
        title: '',
        address: '',
        email: '',
        registrationNumber: '',
        privacyPolicyFile: null,
        privacyPolicyUrl: '',
        status: '',
        simplepayMerchant: '',
        simplepaySecret: '',
        hasSimplepayMerchant: false,
        hasSimplepaySecret: false,
      },
      isEditMerchant: false,
      isEditSecret: false,
    };
  },
  methods: {
    getOrganizer: async function() {
      try {
        this.organizer = await this.organizerRepository.getOrganizer(
          this.organizer.id
        );

        this.key++;
      } catch (error) {}
    },
    updateOrganizer: async function() {
      try {
        const data = {
          title: this.organizer.title,
          address: this.organizer.address,
          email: this.organizer.email,
          registration_number: this.organizer.registrationNumber,
          simplepay_merchant: this.organizer.simplepayMerchant ?? '',
          simplepay_secret: this.organizer.simplepaySecret ?? '',
          status: this.organizer.status,
          privacy_policy_name: this.$refs.privacyPolicyControl.selectedFilename
        };

        if (this.organizer.privacyPolicyFile) {
          data.privacy_policy = this.organizer.privacyPolicyFile;
        }

        await this.organizerRepository.updateOrganizer(
          this.organizer.id,
          data
        );

        store.state.alerts.push(
          new MessageHandler(
            this.__('Organizer was successfully updated.'),
            this.__('Success.'),
            'success'
          )
        );

        await router.push({
          path: '/organizers'
        });
      } catch (error) {
        this.errors = error.data.errors;
      }
    }
  },
  mounted: async function() {
    this.organizer.id = router.currentRoute.params.id;
    await this.getOrganizer();
  }
};
</script>
